import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Comprehensive <span>Automotive App Development</span> Services
            </h2>
            <p>
              We offer specialized automotive app development services designed
              to address the modern challenges of the automotive industry. By
              integrating the latest technology and secure, high-performance
              solutions, we help businesses stay ahead with faster, smarter, and
              more reliable automotive applications. Our services cover
              everything from business-specific operational tools to
              consumer-facing apps, all optimized for seamless performance and
              scalability.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Built My App
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Custom Automotive App Development</h4>
                  <p>
                    Our development team builds apps specifically tailored to
                    your automotive business needs. From telematics to
                    in-vehicle infotainment and fleet management, we leverage
                    technologies like Java, Swift, Kotlin, and Flutter to create
                    robust and scalable apps. Each solution is designed to
                    enhance operational efficiency and user experience while
                    meeting your technical requirements.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Android Automotive App Development</h4>
                  <p>
                    We create high-performance Android apps for automotive use,
                    using the latest Android SDKs and development tools. These
                    apps are engineered for security, speed, and a flawless user
                    experience, whether they’re for driver assistance, vehicle
                    diagnostics, or real-time tracking.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>iOS Automotive App Development</h4>
                  <p>
                    For iOS users, we build secure, feature-rich apps that
                    integrate seamlessly with iOS devices and the Apple
                    ecosystem. Our apps provide intuitive navigation, enhanced
                    user interfaces, and advanced functionality designed for
                    automotive applications, ensuring smooth integration with
                    vehicle systems and mobile services.
                  </p>
                </div>

                <div className="robust-content">
                  <h4>Cross-Platform Automotive App Development</h4>
                  <p>
                    Our cross-platform solutions ensure your app functions
                    perfectly across both iOS and Android platforms, using
                    technologies like React Native and Flutter. These apps offer
                    unified user experiences and faster time-to-market without
                    sacrificing quality or performance, enabling your business
                    to reach a broader audience with one development cycle.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Automotive App Maintenance & Support</h4>
                  <p>
                    Our services extend beyond development to ensure your app
                    performs optimally post-launch. We provide regular updates,
                    security enhancements, performance tuning, and 24/7 support
                    to keep your app running efficiently, securely, and without
                    disruption, allowing your business to focus on scaling and
                    growth.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
